export enum eLoanType {
  CONVENTIONAL = 'CONVENTIONAL',
  FHA = 'FHA',
  HELOC = 'HELOC',
  JUMBO = 'JUMBO',
  USDA = 'USDA',
  VA = 'VA',
  CASH = 'CASH',
  OTHER = 'OTHER',
}

export const DisplayLoanType = {
  [eLoanType.CONVENTIONAL]: 'Conventional',
  [eLoanType.FHA]: 'FHA',
  [eLoanType.HELOC]: 'Heloc',
  [eLoanType.JUMBO]: 'Jumbo',
  [eLoanType.USDA]: 'USDA',
  [eLoanType.VA]: 'VA',
  [eLoanType.CASH]: 'Cash',
  [eLoanType.OTHER]: 'Other',
};
